<template>
  <section class="pre-loader">
    <p>{{ message }}</p>
    <bouncing-spinner></bouncing-spinner>
  </section>
</template>

<script>
export default {
  name: 'PreLoader',
  props: ['message']
}
</script>

<style scoped lang="scss">
.pre-loader {
  margin-top: 30px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  p {
    margin-bottom: 10px;
  }
}
</style>
